export default "__VITE_ASSET__CjyepQ2p__"